export const ASB_SUBTITLE_INDEX_ATTRIBUTE = 'data-asb-subtitle-index';
export const ASB_SUBTITLE_CONTAINER_BOTTOM_CLASS = 'asbplayer-subtitles-container-bottom';
export const ASB_SUBTITLE_CONTAINER_TOP_CLASS = 'asbplayer-subtitles-container-top';
export const ASB_TOKEN_CONTAINER_CLASS = 'asbplayer-token-container';
